import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input } from 'antd'
import { requiredRule, stringRule } from '../../../utils/rules'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item
        name="name"
        label={'Nom'}
        rules={[requiredRule(), stringRule()]}
      >
        <Input />
      </Form.Item>
    </Form>
  )
}

export default Create
